import { useSWR } from '@tiger/swr';
import { CustomerInfoType } from 'types/customer';
import API from 'utils/API';

export function useCustomerInfo(customerId?: number) {
    return useSWR<CustomerInfoType>(
        customerId
            ? {
                  url: API.CUSTOMER.customerInfo(),
                  params: {
                      customer_id: customerId
                  }
              }
            : null,
        {
            dataChain: res => res.data
        }
    );
}
